<template>
    <transition
        name="fade"
        mode="out-in"
    >
        <div
            key="8"
            v-show="isActive == 'all' || isActive == projectCategory"
            :class="'rounded-md bg-gradient-to-br from-' + projectColorFrom + ' to-' + projectColorTo + '  px-4 py-2'"
        >
            <img
                :src="'images/projects/' + projectPhoto"
                class="rounded mb-2 mt-2"
            >

            <div class="grid grid-cols-2">
                <div class="text-left">
                    <h2 class="text-inter-500 text-xl text-white">
                        {{ projectName }}
                    </h2>
                </div>
                <div class="text-right">
                    <a
                        :href="projectLink"
                        class="text-inter-500 text-sm text-white hover:text-blue-200 transition duration-500"
                    >Visit web project</a>
                </div>
            </div>

            <div class="mt-7 grid grid-cols-2">
                <div class="text-left">
                    <span class="mt-3 text-inter-500 text-white text-xs inline-block">Project developed by:</span>
                </div>
                <div>
                    <div v-if="developers.includes('ar')" class="inline-block float-right bg-white rounded-full h-12 w-12 p-1 shadow-md">
                        <a
                            href="https://ar-studio.net"
                            target="_blank"
                        >
                            <img
                                src="images/logos/arstudio.png"
                                class="mt-1 w-max"
                            >
                        </a>
                    </div>
                    <div v-if="developers.includes('t2')" class="inline-block float-right bg-white rounded-full h-12 w-12 p-1 shadow-md mr-2">
                        <a
                            href="https://t2studios.ro"
                            target="_blank"
                        >
                            <img
                                src="images/logos/t2.png"
                                class="w-max"
                            >
                        </a>
                    </div>
                    <div v-if="developers.includes('cds')" class="inline-block float-right bg-white rounded-full h-12 w-12 p-2 shadow-md mr-2">
                         <a
                            href="https://codestage.ro"
                            target="_blank"
                        >
                            <img
                                src="images/logos/logo_color.png"
                                class="w-max"
                            >
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */ {
	opacity: 0;
}
</style>

<script>

export default {
    props: {
        projectName: {
            type: String
        },
        projectLink: {
            type: String
        },
        projectPhoto: {
            type: String
        },
        projectCategory: {
            type: String
        },
        projectColorFrom: {
            type: String
        },
        projectColorTo: {
            type: String
        },
        isActive: {
            type: String
        },
        developers: {
            type: Array
        }
    }
}
</script>